import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import DEFAULTS from "../config/defaults";
import languageCodes from "../config/languageCodes";

export const i18nInit = (translation, lang) => {

    lang = lang || DEFAULTS.lang;

    const resources = {};
    resources[languageCodes[lang]] = {
        "translation": translation
    }

    i18n
        .use(initReactI18next)
        .init({
            resources,
            lng: languageCodes[lang],
            keySeparator: false,
            interpolation: {
                escapeValue: false // react already safes from xss
            }
        });
}


export default i18n;
